"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/** logical operations that can be applied to a list of conditions */
var operationTypes;
(function (operationTypes) {
    operationTypes["And"] = "AND";
    operationTypes["Or"] = "OR";
})(operationTypes = exports.operationTypes || (exports.operationTypes = {}));
/** the full list of condition types */
var conditionTypes;
(function (conditionTypes) {
    /** applies an [[operationTypes]] to a list of conditions */
    conditionTypes["operator"] = "condition.operation";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equal"] = "condition.equal";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqual"] = "condition.not-equal";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equalMaskedMulti"] = "condition.equal-masked-multi";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqualMaskedMulti"] = "condition.not-equal-masked-multi";
    /** checks if an element's value is equal to a given value */
    conditionTypes["equalLabel"] = "condition.equal-label";
    /** checks if an element's value is not equal to a given value */
    conditionTypes["notEqualLabel"] = "condition.not-equal-label";
    /** checks if an element's value is considered empty */
    conditionTypes["empty"] = "condition.empty";
    /** checks if an element's value is not considered empty */
    conditionTypes["notEmpty"] = "condition.not-empty";
    /** checks if an element contains a given value */
    conditionTypes["contains"] = "condition.contains";
    /** checks if an element contains a given string value */
    conditionTypes["containsString"] = "condition.contains-string";
    /** checks if an element does not contain a given string value */
    conditionTypes["notContainString"] = "condition.not-contain-string";
    /** checks if an element's value is equal to the value of another element */
    conditionTypes["equalElement"] = "condition.element.equal";
    /** checks if an element's value is not equal to the value of another element */
    conditionTypes["notEqualElement"] = "condition.element.not-equal";
    /** checks if an element's value is less than a given value */
    conditionTypes["lessThan"] = "condition.less";
    /** checks if an element's value is less than or equal to a given value */
    conditionTypes["lessThanOrEqual"] = "condition.less-or-equal";
    /** checks if an element's value is greater than a given value */
    conditionTypes["greaterThan"] = "condition.greater";
    /** checks if an element's value is greater than or equal to a given value */
    conditionTypes["greaterThanOrEqual"] = "condition.greater-or-equal";
    /** checks if an element's value is less than the value of another element */
    conditionTypes["lessThanElement"] = "condition.element.numeric.less";
    /** checks if an element's value is less than or equal to the value of another element */
    conditionTypes["lessThanOrEqualElement"] = "condition.element.numeric.less-or-equal";
    /** checks if an element's value is greater than the value of another element */
    conditionTypes["greaterThanElement"] = "condition.element.numeric.greater";
    /** checks if an element's value is greater than or equal to the value of another element */
    conditionTypes["greaterThanOrEqualElement"] = "condition.element.numeric.greater-or-equal";
    /** checks if an elements' value begins with a given substring */
    conditionTypes["beginsWith"] = "condition.begins-with";
    /** checks if an elements' value does not begin with a given substring */
    conditionTypes["notBeginWith"] = "condition.not-begin-with";
    /** checks if an elements' value ends with a given substring */
    conditionTypes["endsWith"] = "condition.ends-with";
    /** checks if an elements' value does not end with a given substring */
    conditionTypes["notEndWith"] = "condition.not-end-with";
    /** checks if an element's value contains any of a given number of values */
    conditionTypes["matchesAny"] = "condition.apricot-matches-any";
    /** checks if an element's value does NOT contain any of a given number of values */
    conditionTypes["notMatchAny"] = "condition.apricot-not-match-any";
    /** checks if an element's value contains any of a given number of values */
    conditionTypes["matchesAnyMaskedMulti"] = "condition.apricot-matches-any-masked-multi";
    /** checks if an element's value does NOT contain any of a given number of values */
    conditionTypes["notMatchAnyMaskedMulti"] = "condition.apricot-not-matches-any-masked-multi";
    /** checks if an element's value contains all of a given number of values */
    conditionTypes["matchesEvery"] = "condition.apricot-matches-every";
    /** checks that an element's value does NOT contain every one of a given number of values */
    conditionTypes["notMatchEvery"] = "condition.apricot-not-match-every";
    /** checks if an element's value is earlier than now */
    conditionTypes["earlierThanNow"] = "condition.time.earlier";
    /** checks if an element's value is earlier than or equal to now */
    conditionTypes["earlierThanNowOrEqual"] = "condition.time.earlier-or-equal";
    /** checks if an element's value is later than now */
    conditionTypes["laterThanNow"] = "condition.time.later";
    /** checks if an element's value is later than or equal to now */
    conditionTypes["laterThanNowOrEqual"] = "condition.time.later-or-equal";
    /** checks if an element's value is between two constant values */
    conditionTypes["between"] = "condition.between";
    /** checks if an element's value is not between two constant values */
    conditionTypes["notBetween"] = "condition.not-between";
    /** checks that a date element's value is today */
    conditionTypes["today"] = "condition.today";
    /** checks that a date element's value is NOT today */
    conditionTypes["notToday"] = "condition.not-today";
    /** checks that a date element's value is in the current week */
    conditionTypes["thisWeek"] = "condition.this-week";
    /** checks that a date element's value is NOT in the current week */
    conditionTypes["notThisWeek"] = "condition.not-this-week";
    /** checks that a date element's value is in the current month */
    conditionTypes["thisMonth"] = "condition.this-month";
    /** checks that a date element's value is NOT in the current month */
    conditionTypes["notThisMonth"] = "condition.not-this-month";
    /** checks that a date element's value is in the current year */
    conditionTypes["thisYear"] = "condition.this-year";
    /** checks that a date element's value is NOT in the current year */
    conditionTypes["notThisYear"] = "condition.not-this-year";
    /** checks that a date element's value is within given number of days */
    conditionTypes["last"] = "condition.last";
    /** checks that a date element's value is NOT within given number of days */
    conditionTypes["notLast"] = "condition.not-last";
    /** checks that a date element's value is within given number of days */
    conditionTypes["next"] = "condition.next";
    /** checks that a date element's value is NOT within given number of days */
    conditionTypes["notNext"] = "condition.not-next";
    /** check for static condition being true or false */
    conditionTypes["static"] = "condition.static";
    /** determines if there are no selected programs */
    conditionTypes["programEmpty"] = "condition.program.empty";
    /** determines if there are any selected programs */
    conditionTypes["programNotEmpty"] = "condition.program.not-empty";
    /** determines if there are programs selected that have a name containing some text */
    conditionTypes["programContains"] = "condition.program.contains";
    /** determines if there are no programs selected that have a name containing some text */
    conditionTypes["programNotContains"] = "condition.program.not-contains";
    /** determines if there are programs selected that match a list of program ids */
    conditionTypes["programMatchesAny"] = "condition.program.matches-any";
    /** determines if there are no programs selected that match a list of program ids */
    conditionTypes["programNotMatchesAny"] = "condition.program.not-matches-any";
    /** determines if the programs selected match all program ids in a list */
    conditionTypes["programMatchesAll"] = "condition.program.matches-all";
    /** determines if the programs selected don't match all program ids in a list */
    conditionTypes["programNotMatchesAll"] = "condition.program.not-matches-all";
})(conditionTypes = exports.conditionTypes || (exports.conditionTypes = {}));
/** the full list of action types */
var actionTypes;
(function (actionTypes) {
    /** this action will be ignored, the action reducer will skip this action */
    actionTypes["ignore"] = "action.ignore";
    /** shows a hidden element, changes hidden property to false */
    actionTypes["show"] = "action.show";
    /** hides an element, changes hidden property to true */
    actionTypes["hide"] = "action.hide";
    /** requires a response to an element, changes isRequired to true */
    actionTypes["makeRequired"] = "action.required";
    /** unrequires a response to an element, changes isRequired to false */
    actionTypes["makeNotRequired"] = "action.not-required";
    /** sets an element to a specific value and makes it readOnly so it cannot be edited */
    actionTypes["setValue"] = "action.set-value-readonly";
    /** provides a default value for an element, allows it to be edited*/
    actionTypes["setDefault"] = "action.set-default";
    /** for elements that have validation related to a specific country, this will change which country is being used */
    actionTypes["changeCountry"] = "action.change-country";
    /** makes the given element disabled */
    actionTypes["disable"] = "action.disable";
    /** sets disabled flag to false if it was true */
    actionTypes["enable"] = "action.enable";
    /** locks element, changes readonly property to true */
    actionTypes["lock"] = "action.lock";
    /** unlocks element, changes readonly property to false */
    actionTypes["unlock"] = "action.unlock";
})(actionTypes = exports.actionTypes || (exports.actionTypes = {}));
//# sourceMappingURL=rule-constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/rule-constants.js
// module id = 1110
// module chunks = 0